import cookie from 'js-cookie';

// Set in Cookie
export const setCookie = (key, value) => {
  if (window !== 'undefiend') {
    cookie.set(key, value, {
      // 1 Day
      expires: 1
    });
  }
};
// remove from cookie
export const removeCookie = (key) => {
  if (window !== 'undefined') {
    cookie.remove(key, {
      expires: 1
    });
  }
};

// Get from cookie such as stored token
// Will be useful when we need to make request to server with token
export const getCookie = (key) => {
  if (window !== 'undefined') {
    return cookie.get(key);
  }
};

// Set in localstorage
export const setLocalStorage = (key, value) => {
  if (window !== 'undefined') {
    localStorage.setItem(key, JSON.stringify(value));
  }
};

// Remove from localstorage
export const removeLocalStorage = (key) => {
  if (window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

// Auth enticate user by passing data to cookie and localstorage during signin
export const authenticate = (response) => {
  setCookie('token', response.token);
  setLocalStorage('user', response.user);
};

// Access user info from localstorage
export const isAuth = () => {
  if (window !== 'undefined') {
    const cookieChecked = localStorage.getItem('token');
    if (cookieChecked) {
      if (localStorage.getItem('token')) {
        return localStorage.getItem('token');
      } else {
        return false;
      }
    }
  }
};

export const signout = (next) => {
  removeCookie('token');
  removeLocalStorage('user');
  next();
};

export const updateUser = (response, next) => {
  if (typeof window !== 'undefined') {
    let auth = JSON.parse(localStorage.getItem('user'));
    auth = response;
    // localStorage.setItem('user', JSON.stringify(auth));
    setLocalStorage('user', auth);
  }
  next();
};
